import React from "react";
import { Grid, Button, Typography } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import PeopleIcon from "@material-ui/icons/People";

import { useDispatch } from "react-redux";
import usersActions from "../../../redux/actions/users";

export default function Header() {
  const dispatch = useDispatch();
  return (
    <Grid container direction="row" justify="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h4">
          <PeopleIcon style={{ fontSize: 34, marginBottom: 6 }} /> Usuarios
        </Typography>
      </Grid>
      <Grid item>
        <Button
          onClick={() => dispatch(usersActions.setCreateModal(true))}
          color="primary"
          size="small"
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
        >
          Agregar usuario
        </Button>
      </Grid>
      <Grid item xs={12}>
        <hr />
      </Grid>
    </Grid>
  );
}
